var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEquipmentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4635 5.08922L8.66487 11.1299L3.9751 8.8224L15.5657 3.09913C15.8257 2.96696 16.1377 2.96696 16.4107 3.09913L20.4635 5.08922Z",
    fill: "#151B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0123 8.8225L16.0067 14.77L11.5108 12.5546L10.8608 12.2242L22.6725 6.18457L23.3225 6.51391L28.0123 8.8225Z",
    fill: "#151B26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0446 16.4837L15.0316 28.9995L3.533 22.9989C3.208 22.8277 3 22.4843 3 22.1149V10.5361L7.87286 12.9368V17.1575C7.87286 17.6981 8.31486 18.1466 8.84786 18.1466C9.38087 18.1466 9.82287 17.6981 9.82287 17.1575V13.9129L10.4729 14.2292L15.0446 16.4837Z",
    fill: "#151B26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.987 10.5498L16.9944 16.4713L16.9814 28.9871L29 22.7114L28.987 10.5498Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentBlack);
export default ForwardRef;